import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
  },
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    height: 'calc(100vh - 40px - 40px)',
  },
  inner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    width: 500,
    maxWidth: '100%',
    position: 'relative',
    zIndex: 2,
  },
  title: {
    marginBottom: 24,
  },
  text: {
    marginBottom: 24,
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: 16,
  },
  border: {
    width: '80%',
    border: `1px solid ${theme.palette.secondary.light}`,
    marginBottom: 24,
    marginTop: 8,
  },
  button: {
    width: '100%',
    marginTop: 40,
    paddingTop: 8,
    paddingBottom: 8,
  },
  buttonFailed: {
    width: '100%',
    marginTop: 0,
    paddingTop: 8,
    paddingBottom: 8,
  },
}))
export default useStyles
